export default function Header({
  children,
  className,
  isTextWhite = false,
}: {
  className?: string
  children: React.ReactElement | string
  isTextWhite?: boolean
}): React.ReactElement {
  return (
    <h1
      className={`my-8 text-h3 lg:text-h1 ${isTextWhite ? 'text-white' : 'text-gray-dashboard-header'} ${
        className || ''
      }`}
    >
      {children}
    </h1>
  )
}
